export default "__VITE_ASSET__CKuMu5TH__"